import type { AskGetabstractQuestion, AskGetabstractQuestionAnswers, ChannelMetadata, ContentMetadata, CustomPageListView, FeatureType, FullSearchResults, SearchFiltersForm } from "@newgenerated/shared/schema";
import type { ContentTypes } from "@/components/instant-search/_instant-search";
import type { SimpleComponentUiState } from "@/components/ask-getabstract/utils/backgroundWorker";
import type { ContentTypeFilterProps } from "@/components/sorting-filtering-paging/ContentSortingFiltering";
import type { ContentIxStatusState } from "@/common/ixStatusUtils";

export type FullSearchStoreApiMethods = {
  search: (searchFiltersForm: SearchFiltersForm) => Promise<FullSearchResults>;
  createQuestion: (question: AskGetabstractQuestion) => Promise<void>;
  getQuestionAnswers: (questionUuid: string) => Promise<AskGetabstractQuestionAnswers>;
  hasFeature: (feature: FeatureType) => Promise<boolean>;
};

export const defaultAmount: { [content in ContentTypes]: number } = {
  SUMMARY: 4,
  ACTIONABLE: 6,
  CHANNEL: 4,
  CUSTOMPAGE: 9,
  VERIFAI: 4,
};

export const contentTypeOrder: { [content in ContentTypes]: number } = {
  SUMMARY: 1,
  VERIFAI: 2,
  ACTIONABLE: 3,
  CHANNEL: 4,
  CUSTOMPAGE: 5,
};

export type ContentTypeDiscriminator = "SUMMARY" | "CHANNEL" | "CUSTOMPAGE" | "ACTIONABLE" | "VERIFAI";

export type DataType =
  | {
      kind: "SUMMARY";
      items: ContentMetadata[];
    }
  | {
      kind: "CHANNEL";
      items: ChannelMetadata[];
    }
  | {
      kind: "CUSTOMPAGE";
      items: CustomPageListView[];
    }
  | {
      kind: "ACTIONABLE";
      items: ContentMetadata[];
    }
  | {
      kind: "VERIFAI";
      items: ContentMetadata[];
    };

export type ContentTypeProps = DataType & {
  amountToShow: number;
  title: string;
  filterProps: ContentTypeFilterProps;
  paging: {
    page: number;
    totalCount: bigint;
  };
};

export type ExtendedContentType = ContentTypes | "ALL";

export type SearchAiComponentState =
  | { kind: "NOT_AVAILABLE" }
  | {
      kind: "AVAILABLE";
      uiState: SimpleComponentUiState;
      displayFullAnswer: boolean;
    };

export type SearchStatus = "LOADING" | "LOADMORE" | "IDLE" | "ERROR";

export type SearchProps = {
  status: SearchStatus;
  params: URLSearchParams;
  searchTerm: string;
  selectedContentType: ExtendedContentType;
};

export type SearchStoreState = {
  contentTypeProps: ContentTypeProps[];
  searchProps: SearchProps;
  aiState: SearchAiComponentState;
  ixStatus: ContentIxStatusState;
};
